import React, { useCallback, useRef } from "react";
import { Modal } from "@shopify/polaris";
import { useMutation } from "@apollo/react-hooks";

// import useLockBodyScroll from "../../../hooks/useLockBodyScroll";
import { handleError } from "../../../helper";
import { RE_ASSIGN_TASK } from "../../../graphql/mutations";
import { DesignTaskFormPolaris } from "./DesignTaskFormPolaris";
import { useToastContext } from "../../shared/ToastContext";

export const ReAssignPolaris = (props) => {
    // Props
    const {
        open,
        toggleShowModal,
        refetch,
        task,
        toggleActive,
        onNotificationChange,
    } = props;
    // Block body scroll
    // useLockBodyScroll(open);

    // Ref
    const onCloseRef = useRef(null);

    // Context
    const { setFilter } = useToastContext();

    // Mutation
    const [reAssignTask, { loading }] = useMutation(RE_ASSIGN_TASK, {
        onError: (error) => {
            if (onNotificationChange) {
                onNotificationChange({
                    message: handleError(error.toString()),
                    isError: true,
                });
            }
        },
        onCompleted: () => {
            toggleShowModal();
            if (onNotificationChange) {
                onNotificationChange({
                    message: "Re assign success.",
                    isError: false,
                });
            }

            // onClose parent modal
            onCloseRef.current && clearTimeout(onCloseRef.current);
            onCloseRef.current = setTimeout(() => {
                setFilter && setFilter((prev) => ({ ...prev }));
                refetch && refetch();
            }, 1000);
        },
    });

    // Handle actions
    const handleSubmit = useCallback(
        (input) => {
            let id = task?.id;
            if (onNotificationChange) {
                onNotificationChange({
                    message: null,
                    isError: false,
                });
            }
            if (input && id) {
                reAssignTask({
                    variables: {
                        input: {
                            ...input,
                            id,
                        },
                    },
                });
                if (toggleActive) {
                    toggleActive();
                }
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [task]
    );

    return (
        <Modal
            title="Re-assign"
            open={open}
            onClose={toggleShowModal}
            sectioned
        >
            <DesignTaskFormPolaris
                onSubmit={handleSubmit}
                loadingM={loading}
                toggleShowModal={toggleShowModal}
                value={task}
            />
        </Modal>
    );
};
